(function ($) {
  "use strict";
  jQuery(document).ready(function(){
    var windows = $(window);
    var sticky = $('.header-sticky');
    if (sticky.length) {
      var stickyTicking = false;
      var isStuck = false;
      var lastScroll = 0;
      var headerHeight = sticky.outerHeight();
      var dirDelta = 5; // ignora micro-movimientos para no parpadear

      function updateHeader() {
        var current = windows.scrollTop();
        // Enganche: solo al pasar el alto del header (viniendo de bajar), cuando ya
        // se fue de pantalla → pasar a fixed + ocultarlo es imperceptible.
        if (current > headerHeight && !isStuck) {
          isStuck = true;
          headerHeight = sticky.outerHeight();
          // Compensa el salto: el header sale del flujo → rellenamos su alto.
          $('body').css('padding-top', headerHeight + 'px');
          // Nace YA oculto y SIN animar (no "aparece entero y se va"). El reflow
          // forzado fija el estado oculto al instante; reactivamos la transición.
          sticky.addClass('no-anim is-sticky header-hidden');
          sticky[0].offsetHeight;
          sticky.removeClass('no-anim');
        }
        if (isStuck) {
          if (current <= 0) {
            // Desenganche SOLO en el tope: ahí la posición fixed coincide con la del
            // flujo, así que volver a relative es imperceptible (sin salto al subir).
            isStuck = false;
            sticky.removeClass('is-sticky header-hidden');
            $('body').css('padding-top', '');
          } else if (current > lastScroll + dirDelta) {
            sticky.addClass('header-hidden');     // baja → oculta
          } else if (current < lastScroll - dirDelta) {
            sticky.removeClass('header-hidden');  // sube → muestra el nav
          }
        }
        lastScroll = current <= 0 ? 0 : current;
      }

      windows.on('scroll', function() {
        if (!stickyTicking) {
          window.requestAnimationFrame(function() {
            updateHeader();
            stickyTicking = false;
          });
          stickyTicking = true;
        }
      });
      // El header cambia de alto entre desktop/mobile: recalculamos en resize.
      windows.on('resize', function() {
        headerHeight = sticky.outerHeight();
        if (isStuck) $('body').css('padding-top', headerHeight + 'px');
      });
    }
    $("button.navbar-toggler").click(function(){
      $(".main-menu-area").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("hidden");
    });
    $(".close-box").click(function(){
      $(".main-menu-area").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden");
    });
    $(".mm-fullscreen-bg").click(function(){
      $(".main-menu-area").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $(".filter-sidebar").removeClass("active");
      $("body").removeClass("hidden");
    });
    $("button.filter-button").on('click', function() {
      $(".filter-sidebar").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
    });
    $("button.close-filter-sidebar").on('click', function() {
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
    });
    $('.full-view, .zoom').on('click', function() {
      $('.product_img_top').magnificPopup({
        delegate: 'a',
        type:'image',
        showCloseBtn: true,
        closeBtnInside: false,
        midClick: true,
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0,1]
        }
      }).magnificPopup('open');
    });
    $(window).scroll(function(){
      if ($(this).scrollTop() > 1000) {
        $('#top').fadeIn();
      } else {
        $('#top').fadeOut();
      }
    });
    $('#top').click(function(){
      $("html, body").animate({ scrollTop: 0 }, 100);
      return false;
    });
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl)
    })
  });
})(jQuery);